import React from 'react';
import EditarIngresos from '../../../components/insumos/ingresos/EditarIngresos';

const EditarIngresosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <EditarIngresos />
    </div>
  );
};

export default EditarIngresosPage;